import { t } from 'i18next';
import { cn } from '@datanomik/core-ui';
import { GlobalLine, MoonLine, SunLine } from '@datanomik/core-ui/icons';

import { useThemeMode, type ThemeMode } from './useThemeMode';

const OPTIONS: { mode: ThemeMode; label: string; Icon: typeof SunLine }[] = [
  { mode: 'light', label: 'Light', Icon: SunLine },
  { mode: 'dark', label: 'Dark', Icon: MoonLine },
  { mode: 'system', label: 'Same as my system', Icon: GlobalLine },
];

export function ThemeModeToggle({ className }: { className?: string }) {
  const { mode, selectMode } = useThemeMode();

  return (
    <div
      role="radiogroup"
      aria-label={t('Theme')}
      className={cn(
        'inline-flex items-center gap-0.5 rounded-lg border border-input bg-muted p-0.5',
        className,
      )}
    >
      {OPTIONS.map(({ mode: option, label, Icon }) => {
        const active = mode === option;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => selectMode(option)}
            className={cn(
              'flex cursor-pointer items-center gap-1.5 rounded-md px-2.5 py-1.5 text-[13px] font-medium transition-colors',
              'outline-none focus-visible:ring-2 focus-visible:ring-ring/40',
              active
                ? 'bg-primary-subtle text-primary-subtle-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            <Icon aria-hidden="true" className="size-4" />
            {t(label)}
          </button>
        );
      })}
    </div>
  );
}
